import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { authActions } from '../actions';

import scLogo from '../assets/icon.png';
import scLogoWide from '../assets/simcase_wide.png';
import appLogo from '../assets/app_icon.png';

const AuthPage = () => {
  const location = window.location;

  // State
  const [error, setError] = useState(null);

  // Hooks
  const { t } = useTranslation();
  const dispatch = useDispatch();
  // const user = useSelector((state) => state.authentication.user);

  // Effects
  useEffect(() => {
    if (location.search.length > 0) {
      setTimeout(
        () => dispatch(authActions.authenticate(location.search)),
        2000
      );
    } else {
      setError('Missing code');
    }
  }, [dispatch, location.search]);

  return (
    <div className='row bgcolors'>
      <div
        className='panel-sidebar col-3 text-center d-none d-md-block'
        style={{ height: '100vh' }}>
        <p className='v-center'>
          <img
            src={scLogoWide}
            className='mb-3'
            style={{ maxWidth: '50%' }}
            alt='SimCase'
          />
          <br />
          <small>
            <a
              href='http://simcase.io'
              target='_blank'
              rel='noopener noreferrer'>
              {t('Learn More')}
            </a>
          </small>
        </p>
      </div>
      <div
        className='col-12 col-sm-10 offset-sm-1 col-md-5 offset-md-5 text-center'
        style={{ height: '100vh' }}>
        <div className='v-center'></div>
        <div className='card'>
          <div className='card-body pt-5 pb-5'>
            <h3 className='mt-0 mb-0 title-font font-weight-light'>
              {t('Authenticating...')}
            </h3>
            <img
              src={appLogo}
              style={{ maxHeight: '180px' }}
              className='img-fluid mt-3 mb-3'
              alt=''
            />
            <br />
            <p className='mt-5 mb-0 d-md-none text-center'>
              <img src={scLogo} style={{ width: '25px' }} alt='' />
              <br />
              <small className='text-secondary'>
                {t('Developed by Simcase')}
              </small>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export { AuthPage };
